
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "OurTransportTransportation",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: 1.5,
        slidesPerGroup: 1,

        breakpoints: {
          1200: {
            spaceBetween: 20,
            slidesPerView: 4.5,
            slidesPerGroup: 4.5,
          },
          1024: {
            slidesPerView: 3.5,
            slidesPerGroup: 3.5,
          },
          860: {
            slidesPerView: 2.5,
            slidesPerGroup: 2.5,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
        navigation: {
          prevEl: `.our-transport-transportation__button-navition--prev-${this._uid}`,
          nextEl: `.our-transport-transportation__button-navition--next-${this._uid}`
        },
      }
    }
  },

  props: {
    title: {
      type: String,
      default: ""
    },
    products: {
      type: Array,
      default: () => {
        return []
      }
    },

    light: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
  },

  components: {
    Swiper,
    SwiperSlide,

    Card: () => import("~/components/category/ProductCardSmallImage.vue")
  }
}
